import cls from "./customHeader.module.scss"
import React, {FC} from "react";
import FirstSection from "./FirstSection";
import {IFirstHeader} from "../MainLayout";
import {useSelector} from "react-redux";
import {IState} from "../../../../types/state";
import CustomSearch from "./CustomSearch";

interface IProps extends IFirstHeader {
    isMobile: boolean;
}

const CustomHeader: FC<IProps> = (
    {
        logoPath,
        dbName,
        domain,
        menus,
        hasBlog,
        selectedRate,
        isTwoKings,
        categories,
        selectedLocale,
        translationsData,
        backOrderValue,
        isSocialLinksActive,
        allowCheckoutValue,
        selectedLocaleImg,
        locales,
        cacheControlVersion,
        isMobile,
        showAccount,
        showWishlist,
        showCart,
        showSearch,
        defaultLangCode,
        themeOptions,
        isOhmTheme,
        searchShowDetails,
        showCategories,
        metas
    }
) => {
    const openSearch = useSelector((state: IState) => state.mobileMenu.searchOpen) || false


    const classSearchOpen = {
        true: `${cls["mobile-header__search--open"]} ${cls["mobile-header__search"]}`,
        false: cls["mobile-header__search"]
    }

    const hasSearch = {
        "true": <div className={`${cls["site-header__search"]} ${classSearchOpen[`${openSearch}`]}`}
                     style={!showAccount && !showWishlist && !showCart ? {justifyContent: "center"} : {}}
        >
            <CustomSearch
                translationsData={translationsData}
                selectedLocale={selectedLocale}
                dbName={dbName}
                selectedRate={selectedRate}
                backOrderValue={backOrderValue}
                changePosition={!showAccount && !showWishlist && !showCart}
                showCart={showCart}
                defaultLangCode={defaultLangCode}
                domain={domain}
                searchShowDetails={searchShowDetails}
                metas={metas}
            />
        </div>,
        "false": null
    }

    return <div className={cls.header}>
        <FirstSection
            dbName={dbName}
            domain={domain}
            logoPath={logoPath}
            menus={menus}
            hasBlog={hasBlog}
            selectedLocaleImg={selectedLocaleImg}
            translationsData={translationsData}
            locales={locales}
            cacheControlVersion={cacheControlVersion}
            themeOptions={themeOptions}
            categories={categories}
            isTwoKings={isTwoKings}
            showAccount={showAccount}
            selectedRate={selectedRate}
            showWishlist={showWishlist}
            showCart={showCart}
            showSearch={showSearch}
            selectedLocale={selectedLocale}
            backOrderValue={backOrderValue}
            defaultLangCode={defaultLangCode}
            isMobile={isMobile}
            isSocialLinksActive={isSocialLinksActive}
            allowCheckoutValue={allowCheckoutValue}
            isOhmTheme={isOhmTheme}
            searchShowDetails={searchShowDetails}
            showCategories={showCategories}
            metas={metas}
        />
        {openSearch ? hasSearch[`${showSearch}`] : null}
    </div>
};

export default CustomHeader;